<script setup>

import {computed} from "vue";
import {round10} from '@/math'
import { store } from "@/store";

const chartBars = computed(() => {
  const savings = store.formData.savings,
      chartBarsAll = [
        {
          value: savings.other.totalWeekly,
          displayValue: '£' + round10(savings.other.totalWeekly),
          label: 'per week from other sources',
          color: '#275e6f'
        },
        {
          value: otherSavingsValue.value,
          displayValue: '£' + round10(otherSavingsValue.value),
          label: 'per week from your other pensions',
          color: '#055a60'
        },
        {
          value: savings.personal.totalWeekly,
          displayValue: '£' + round10(savings.personal.totalWeekly),
          label: 'per week from your Personal Account',
          color: '#baabc5'
        }
      ]
  console.log(chartBarsAll)
  chartBarsAll.forEach(function (bar) {
    bar.posCent = 100 * bar.value / chartMax.value
  });

  return chartBarsAll.filter(bar => bar.posCent > 0)
})
const otherSavingsValue = computed(() => {
  let otherSavingsRollup = store.formData.savings.dc.totalWeekly + store.formData.savings.db.totalWeekly;
  if (!store.formData.user.sraBeforeSpa) otherSavingsRollup += store.formData.savings.state.totalWeekly;
  return otherSavingsRollup
})
const chartTotal = computed(() => {
  const weeklyTotal = store.formData.savingsTotal.weekly
  return {
    value: weeklyTotal,
    displayValue: '£' + round10(weeklyTotal),
    label: 'per week total income',
    color: '#73787c',
    posCent: 100 * weeklyTotal / chartMax.value,
    position: canAfford ? 'top' : 'bottom'
  }
})
const chartTarget = computed(() => {
  const weeklyTarget = store.formData.standardTotal.value
  return {
    value: weeklyTarget,
    displayValue: '£' + round10(weeklyTarget),
    label: 'per week desired income',
    color: '#eb5c37',
    posCent: 100 * weeklyTarget / chartMax.value,
    position: !canAfford.value ? 'top' : 'bottom'
  }
})
const chartMax = computed(() => {
  return canAfford.value ? store.formData.savingsTotal.weekly : store.formData.standardTotal.value
})
const canAfford = computed(() => {
  return (store.formData.savingsTotal.weekly >= store.formData.standardTotal.value)
})
const chartClass = computed(() => {
  let chartClass = 'results-chart';
  chartClass = canAfford.value ? chartClass + ' total-top' : chartClass + ' target-top';
  return chartClass
})
</script>

<template>
  <div class="results-chart">
    <h3 class="rc__title">How your retirement income stacks up </h3>
    <div class="rc__bars">
      <div
          class="rc__bar"
          v-for="(bar, index) in chartBars"
          v-bind:key="index"
          v-bind:style="{ height: bar.posCent + '%'}"
      >
        <span class="rc__fill" v-bind:style="{ backgroundColor: bar.color }"></span>
        <div
            class="rc__label"
            v-bind:style="{ color: bar.color }"
        >
          <strong>{{ bar.displayValue }}</strong><br>
          <span>{{ bar.label }}</span>
        </div>
      </div>

      <div
          class="rc__total"
          v-bind:style="{ bottom: chartTotal.posCent + '%' }"
      >
        <span class="rc__fill" v-bind:style="{ backgroundColor: chartTotal.color }"></span>
        <div
            :class="'rc__label ' + chartTotal.position"
            v-bind:style="{ color: chartTotal.color }"
        >
          <div class="rc__tab" v-bind:style="{ backgroundColor: chartTotal.color }">
            <strong>{{ chartTotal.displayValue }}</strong>
            <span> {{ chartTotal.label }}</span>
          </div>
        </div>
      </div>

      <div
          class="rc__target"
          v-bind:style="{ bottom: chartTarget.posCent + '%' }"
      >
        <span class="rc__fill" v-bind:style="{ backgroundColor: chartTarget.color }"></span>
        <div
            :class="'rc__label ' + chartTarget.position"
        >
          <div class="rc__tab" v-bind:style="{ backgroundColor: chartTarget.color }">
            <strong>{{ chartTarget.displayValue }}</strong>
            <span> {{ chartTarget.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
